module.exports = __webpack_public_path__ + "static/media/closeMenu.ed505056.svg";